export default class MultiSelectConfigOption {
    public key: string = "";
    public label: string = "";
}